<script lang="ts">
	import PolicyPage from '$lib/components/PolicyPage.svelte';
</script>

<PolicyPage title="Privacy Policy" description="Privacy policy for healthyshoes.com.cy. Minimal data collection for order processing only.">
	<h2>Overview</h2>
	<p>
		At Healthy Shoes Cyprus, we believe in keeping things simple. We collect the minimum
		amount of data needed to process your orders and provide a good shopping experience.
	</p>

	<h2>What We Collect</h2>
	<p>We only collect information that you provide directly to us:</p>
	<ul>
		<li>Name, email, and shipping address when you place an order</li>
		<li>Payment details (processed securely by Shopify — we never see your full card number)</li>
		<li>Account information if you choose to create an account</li>
	</ul>

	<h2>What We Don't Collect</h2>
	<p>
		We do not use any analytics or tracking tools. There is no Google Analytics, no Facebook Pixel,
		and no third-party advertising trackers on this site. We don't track your browsing behaviour
		or build advertising profiles.
	</p>

	<h2>How We Use Your Data</h2>
	<p>Your information is used solely to:</p>
	<ul>
		<li>Process and deliver your orders</li>
		<li>Communicate with you about your order (confirmation, shipping updates)</li>
		<li>Provide customer support when you contact us</li>
	</ul>

	<h2>Third-Party Services</h2>
	<ul>
		<li>
			<strong>Shopify</strong> — processes orders and payments. Shopify's privacy policy
			governs how they handle order data.
		</li>
		<li>
			<strong>Google Maps</strong> — used on our Find Us page. Google's privacy policy
			applies when you interact with the map.
		</li>
	</ul>

	<h2>Your Rights (GDPR)</h2>
	<p>You have the right to:</p>
	<ul>
		<li><strong>Access</strong> — request a copy of the personal data we hold about you</li>
		<li><strong>Correction</strong> — ask us to correct any inaccurate information</li>
		<li><strong>Deletion</strong> — request that we delete your personal data</li>
		<li><strong>Portability</strong> — receive your data in a structured, machine-readable format</li>
	</ul>
	<p>
		To exercise any of these rights, please contact us using the details below.
	</p>

	<h2>Contact</h2>
	<p>
		If you have any questions about this privacy policy or your personal data, contact us at:
	</p>
	<ul>
		<li>Email: <a href="mailto:info@orthohouse.com.cy">info@orthohouse.com.cy</a></li>
		<li>Phone: <a href="tel:+35722660688">+357 22 66 06 88</a></li>
		<li>Address: 27, 25th March Street, Engomi, 2408 Nicosia, Cyprus</li>
	</ul>
</PolicyPage>
